class CampaignPlanningConfirmationModalSendQuote {
  constructor() {
    this.main = document.getElementById('checkout_modal_send_send_quote');
    this.totalPrice = null;
    this.dataClient = null;

    this._paymentOptionDigital =
      this.main.querySelector('.payment-option[data-type="Digital"]') || null;
    this._paymentOptionClient = this.main.querySelector(
      '.payment-option__client'
    );

    this._modalOptionsContent = this.main.querySelector('.modal-options');
    this._modalStatusContent = this.main.querySelector('.modal-status');
    this._modalResponseContent = this.main.querySelector('.modal-response');

    this._btnClose = this.main.querySelector('.btn_close');
    this._btnCloseError = this.main.querySelector('.btn_close_error');
    this._btnContinue = this.main.querySelector('.btn_send_quote');

    this._btnCloseError.addEventListener(
      'click',
      this._onClickBtnCloseError.bind(this)
    );
    this._btnClose.addEventListener('click', this._onClickBtnClose.bind(this));
    if (this._paymentOptionDigital != null)
      this._btnContinue.addEventListener('click', e => {
        this.main.dispatchEvent(new CustomEvent('PAYMENT_SEND_QUOTE_FUNNEL'));
      });
  }

  set setResponseContent(message) {
    if (message) {
      this._modalResponseContent.querySelector(
        '.modal-response--text'
      ).innerHTML = `${message}`;
    }
  }

  set showStatusContent(value) {
    if (value) {
      this._modalOptionsContent.classList.add('d-none');
      this._modalStatusContent.classList.remove('d-none');
    } else {
      this._modalOptionsContent.classList.remove('d-none');
      this._modalStatusContent.classList.add('d-none');
    }
  }

  set showResponseContent(value) {
    if (value) {
      this._modalStatusContent.classList.add('d-none');
      this._modalResponseContent.classList.remove('d-none');
    } else {
      this._modalStatusContent.classList.remove('d-none');
      this._modalResponseContent.classList.add('d-none');
    }
  }

  set setTotalPrice(data) {
    this.totalPrice = data;
  }

  set setClient(data) {
    if (data) {
      this.dataClient = data;
      this.updateClient();
    }
  }

  set loadingSendQuote(value) {
    if (value) {
      this._btnContinue.classList.add('button--loading');
    } else {
      this._btnContinue.classList.remove('button--loading');
    }
  }

  updateClient() {
    let name = this._paymentOptionClient.querySelector('.name');
    let email = this._paymentOptionClient.querySelector('.email');
    if (this.dataClient) {
      name.innerHTML = this.dataClient.organization.name + ' - ' + this.dataClient.name;
      if (this.dataClient.customer) {
        email.innerHTML = this.dataClient.customer.email;
      }
      if (this.dataClient.organization.customer) {
        email.innerHTML = this.dataClient.organization.customer.email;
      }
    }
  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }

  show() {
    this.main.classList.add('modal--show');
    document.body.classList.add('block-scroll');
    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }

  hide() {
    this.loading = false;
    this.main.classList.remove('modal--anim');
    setTimeout(() => {
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
    }, 750);
  }

  set loading(value) {
    if (value) {
      this.main.classList.add('loading');
    } else {
      this.main.classList.remove('loading');
    }
  }

  _onClickBtnClose(e) {
    e.preventDefault();
    this.hide();
  }

  _onClickBtnCloseError(e) {
    e.preventDefault();
    location.reload();
  }
}

export default CampaignPlanningConfirmationModalSendQuote;
